module.exports = __webpack_public_path__ + "static/WEDDING E&M-363-4692001a6438912ed9ee4505d7048768.jpg";